import * as _ from 'lodash';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ModalState} from '../reducers/ngbModal.reducer';

const _selectModalRootState = createFeatureSelector<ModalState>('modal');
export const selectIsModalOpened = (modalName: string) => createSelector(
  _selectModalRootState,
  (rootState: ModalState): boolean => _.get(rootState, `ngbModals['${modalName}']`, false)
);
